module.exports = __webpack_public_path__ + "static/img/arrow-right.dcb3bde6.svg";